module.exports = __webpack_public_path__ + "static/media/tags-image-fr.7ea074b3.png";